import { IMicromobilityData } from '../../../models/labs/micromobility/micromobility-data.model';
import { StationApiModel } from './station.api-model';
import { VehicleApiModel } from './vehicle.api-model';

export class MicromobilityDataApiModel {
  public stations!: StationApiModel[];
  public docklessVehicles!: VehicleApiModel[];

  public static mapToBusinessModel(apiModel: MicromobilityDataApiModel): IMicromobilityData {
    return {
      stations: apiModel.stations.map(StationApiModel.mapToBusinessModel),
      docklessVehicles: apiModel.docklessVehicles.map(VehicleApiModel.mapToBusinessModel),
    };
  }
}
